import { render, staticRenderFns } from "./userBranchSummary.vue?vue&type=template&id=217b02a8"
import script from "./userBranchSummary.vue?vue&type=script&lang=js"
export * from "./userBranchSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports